module.exports = __webpack_public_path__ + "static/img/newimg3.95f9cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg3.png
// module id = LiUd
// module chunks = 1